module.exports = __webpack_public_path__ + "img/9-07.aed0cbdc.jpg";